module.exports = __webpack_public_path__ + "img/people-bg-auth.da25d3d8.png";